<template>
  <div class="metric">
    <div v-if="icon" class="metric-icon" :style="iconStyle" v-html="icon" />
    <span class="metric-label">{{ label }}</span>
    <span class="metric-value sm" :class="valueClass">{{ value }}</span>
    <span v-if="foot" class="metric-foot">{{ foot }}</span>
    <span v-if="trend" class="kpi-trend" :class="`kpi-trend--${trend.dir}`">
      {{ trend.dir === "up" ? "▲" : "▼" }} {{ trend.text }}
    </span>
  </div>
</template>

<script>
// Card de KPI/métrica reutilizável (.metric do DS).
export default {
  name: "ClinicKpi",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    icon: { type: String, default: "" }, // svg inline (opcional)
    iconColor: { type: String, default: "primary" }, // primary|accent|success|warning|danger
    foot: { type: String, default: "" },
    trend: { type: Object, default: null }, // { dir:'up'|'down', text:'5%' }
    valueClass: { type: String, default: "" } // ex.: 'money--pos'
  },
  computed: {
    iconStyle() {
      const c = this.iconColor;
      return {
        background: `var(--color-${c}-light)`,
        color: `var(--color-${c})`
      };
    }
  }
};
</script>
